export const DEFAULT_LOCALE = 'en-US';

export const SUPPORTED_APP_LOCALES = [
    'en-US',
    'ja-JP',
    'ko-KR',
    'zh-TW'
] as const;

export type SupportedAppLocale = typeof SUPPORTED_APP_LOCALES[number];

export function isSupportedLocale(locale: string | null | undefined): locale is SupportedAppLocale {
    return SUPPORTED_APP_LOCALES.includes(locale as SupportedAppLocale);
}
